import { notesMigrationTypes } from "redux/reducers/notesMigration/notesMigrationTypes";
import { api_post, api_get, PROYECT } from "services/api";
import { startRequestComp, stopRequestComp, setSnackbar } from "../search/searchActions";

const {
  SET_NOTES_MIGRATION_FILTERS,
  GET_NOTES_MIGRATION,
  SELECT_NOTE_TO_MIGRATE,
  DESELECT_NOTE_TO_MIGRATE,
  DO_NOTES_MIGRATION,
  ERROR_NOTES_MIGRATION,
  CLEAR_NOTES_MIGRATION,
  SET_CONFIG_FILTER_NOTES_MIGRATION,
  SET_CONFIG_PAGE_NOTES_MIGRATION,
  SET_CONFIG_PAGE_SIZE_NOTES_MIGRATION,
  SET_CONFIG_SORTED_NOTES_MIGRATION,
  REMOVE_NOTES_SELECTION,
  UPDATE_NOTE_MIGRATION,
} = notesMigrationTypes

export const getAllNotesMigration = () => {
  const url = `${process.env.REACT_APP_URL}${PROYECT}/notes/daily-notes`
  return async (dispatch) => {
    dispatch(startRequestComp('loadingNotesMigration'))
    await api_get(url).then(resp => {
      dispatch({
        type: GET_NOTES_MIGRATION,
        payload: resp
      })
    }).catch(error => dispatch(setSnackbar(error)))
    dispatch(stopRequestComp('loadingNotesMigration'))
  }
}

export const getNotesMigration = (startDate, endDate, stations) => {
  const baseUrl = `${process.env.REACT_APP_URL}${PROYECT}/notes/daily-notes?start=${startDate}&end=${endDate}`
  const params = stations.map(id => `stations=${id}`).join('&')
  const url = `${baseUrl}&${params}`

  return async (dispatch) => {
    dispatch(startRequestComp('loadingNotesMigration'))
    await api_get(url).then(resp => {
      resp.length === 0 && dispatch(setSnackbar("No se encontraron notas", "warning"))
      dispatch({
        type: GET_NOTES_MIGRATION,
        payload: resp
      })
    }).catch(error => dispatch(setSnackbar(error)))
    dispatch(stopRequestComp('loadingNotesMigration'))
  }
}


export const doNotesMigration = (ids, action = null) => {
  const url = `${process.env.REACT_APP_URL}${PROYECT}/notes/migrate-oracle/unsent`
  return async (dispatch) => {
    dispatch(startRequestComp('loadingNotesMigrationActions'))

    try {
      const resp = await api_post(url, { ids })
      dispatch({
        type: DO_NOTES_MIGRATION,
        payload: resp
      })
      dispatch(setSnackbar("Notas enviadas correctamente", "success"))
      action && action()
    } catch (error) {
      const uuidAndMsg = error.split(',')
      if (/\[[0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12}\]/.test(uuidAndMsg[0])) {
        dispatch({
          type: ERROR_NOTES_MIGRATION,
          payload: uuidAndMsg[0].slice(1, uuidAndMsg[0].length - 1)
        })
        dispatch(setSnackbar(uuidAndMsg[1] ? uuidAndMsg[1] : "Error contacte al administrador"))
      } else dispatch(setSnackbar(error))
      action && action()
    }

    dispatch(stopRequestComp('loadingNotesMigrationActions'))
  }
}

export const cancelMigration = (form, action = null) => {
  const url = `${process.env.REACT_APP_URL}${PROYECT}/notes/migrate-oracle/cancel-migration`
  return async (dispatch) => {
    dispatch(startRequestComp('loadingNotesMigrationActions'))
    await api_post(url, form).then(resp => {
      dispatch({
        type: UPDATE_NOTE_MIGRATION,
        payload: resp[0]
      })
      dispatch(setSnackbar("cancelación enviada", "success"))
      action && action()
    }).catch(error => dispatch(setSnackbar(error)))
    dispatch(stopRequestComp('loadingNotesMigrationActions'))
  }
}

export const resendMigration = (form, action = null) => {
  const url = `${process.env.REACT_APP_URL}${PROYECT}/notes/migrate-oracle/send-migration-with-next-suffix`
  return async (dispatch) => {
    dispatch(startRequestComp('loadingNotesMigrationActions'))
    await api_post(url, form).then(resp => {
      dispatch({
        type: UPDATE_NOTE_MIGRATION,
        payload: resp[0]
      })
      dispatch(setSnackbar("Nota reenviada", "success"))
      action && action()
    }).catch(error => dispatch(setSnackbar(error)))
      .finally(() =>
        dispatch(stopRequestComp('loadingNotesMigrationActions'))
      )
  }
}

export const clearNotesMigration = () => ({
  type: CLEAR_NOTES_MIGRATION,
})

export const selectNoteToMigrate = (id) => ({
  type: SELECT_NOTE_TO_MIGRATE,
  payload: id
})

export const toggleFivePerThousand = (id) => ({
  type: notesMigrationTypes.TOGGLE_FIVE_PER_THOUSAND,
  payload: id
})

export const removeNotesSelection = () => {
  return {
    type: REMOVE_NOTES_SELECTION,
  }

}
export const deselectNoteToMigrate = (id) => ({
  type: DESELECT_NOTE_TO_MIGRATE,
  payload: id
})

export const setNotesMigrationFilters = (key = "", data) => ({
  type: SET_NOTES_MIGRATION_FILTERS,
  payload: { data, key }
})

export const setConfigPageNotesMigration = (page) => ({
  type: SET_CONFIG_PAGE_NOTES_MIGRATION,
  payload: page,
})

export const setConfigPageSizeNotesMigration = (pageSize) => ({
  type: SET_CONFIG_PAGE_SIZE_NOTES_MIGRATION,
  payload: pageSize,
})

export const setConfigFilterNotesMigration = (filter) => ({
  type: SET_CONFIG_FILTER_NOTES_MIGRATION,
  payload: filter,
})

export const setConfigSortedNotesMigration = (sort) => ({
  type: SET_CONFIG_SORTED_NOTES_MIGRATION,
  payload: sort,
})